
import { defineComponent, Ref, ref } from 'vue'
import { message, Form } from 'ant-design-vue'
import {LoadingOutlined} from '@ant-design/icons-vue'
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
import { useStore } from 'vuex'
import {StateType as LoadingStateType} from '@/store/loding'


import {StateType as LogisticsStateType} from '../../store'
interface cancelorderData {
    loading: Ref<boolean>;
    orderBatchList: any;
    handleCtrl: (e: MouseEvent) => void;
    handleGoto: (e: MouseEvent) => void;

}
export default defineComponent({
    name: 'cancelorder',
    props: {
        typeStr: {
            type: String
        },
        orderList: {
            type: Object
        }
    },
    components:{
        ExclamationCircleFilled
    },
    emits: ['update:visible','commit'],
    setup(props, {emit}):cancelorderData {
        const loading = ref<boolean>(false)
        const orderBatchList = ref<any>([])
        const store = useStore<{
            loading: LoadingStateType,
            logisticsquery: LogisticsStateType,
        }>()
        // 批量取消订单
        const orderBatchCancelFn = async(params:any) => {
            loading.value = true
            try {
                let res: boolean = await store.dispatch('logisticsquery/orderBatchCancelFn',params)
                if(res===true){
                    orderBatchList.value = store.state.logisticsquery.orderBatchListData
                    if(orderBatchList.value && orderBatchList.value.length < 1){
                        emit('update:visible', false)
                        emit('commit','statusCommit')
                        message.success('订单取消中，等待取消结果')
                    }
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
            loading.value = false
        }

        const handleCtrl = (e: MouseEvent) => {
            emit('update:visible', false)
        }

        const handleGoto = (e: MouseEvent) => {
            orderBatchCancelFn(props.orderList)
        }

        return {
            loading,
            handleCtrl,
            handleGoto,
            orderBatchList
        }
    }
})


